import actions from './actions';

const initState = {
	dataSummarizeSpokenText: [],
	summarizeSpokenTextDetail: null,
	totalItems: 0,
	loading: false,
};

export default function summarizeSpokenTextReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_SUMMARIZE_SPOKEN_TEXT:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_SUMMARIZE_SPOKEN_TEXT_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataSummarizeSpokenText: res, totalItems, loading: false };

		case actions.GET_SUMMARIZE_SPOKEN_TEXT_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_SUMMARIZE_SPOKEN_TEXT_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, summarizeSpokenTextDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
